import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.kyc.title',
        defaultMessage: 'Let’s verify your identity',
    },
    subtitle: {
        id: 'modal.kyc.subtitle',
        defaultMessage: 'To issue your card, we need a few more details, starting with your address',
    },
    button: {
        id: 'modal.kyc.button',
        defaultMessage: 'Verify now',
    },
})
